import { TableSortDirection } from '@amzn/meridian/table/table';

export const translateToLodashSortDirection = (sortDirection: TableSortDirection) => {
    return sortDirection === 'ascending' ? 'asc' : 'desc';
};
